import * as Yup from 'yup'

export interface UpdateCompanyAddressRequest {
    ds_zipcode: string
    ds_street: string
    ds_number: string
    ds_complement: string
    ds_neighborhood: string
    ds_city: string
    ds_state: string
}

export const updateAddressInitialValues: UpdateCompanyAddressRequest = {
    ds_zipcode: '',
    ds_street: '',
    ds_number: '',
    ds_complement: '',
    ds_neighborhood: '',
    ds_city: '',
    ds_state: '',
}

export const updateAddressValidationSchema = Yup.object().shape({
    ds_zipcode: Yup.string().required('Campo obrigatório'),
    ds_street: Yup.string().required('Campo obrigatório'),
    ds_number: Yup.string().required('Campo obrigatório'),
    ds_neighborhood: Yup.string().required('Campo obrigatório'),
    ds_city: Yup.string().required('Campo obrigatório'),
    ds_state: Yup.string().required('Campo obrigatório'),
})